import request from '@/utils/request'


// 查询赛事红包领取记录列表
export function listCompetitionPacketUser(query) {
  return request({
    url: '/platform/competition-packet-user/list',
    method: 'get',
    params: query
  })
}

// 查询赛事红包领取记录分页
export function pageCompetitionPacketUser(query) {
  return request({
    url: '/platform/competition-packet-user/page',
    method: 'get',
    params: query
  })
}

// 查询赛事红包领取记录详细
export function getCompetitionPacketUser(data) {
  return request({
    url: '/platform/competition-packet-user/detail',
    method: 'get',
    params: data
  })
}

// 新增赛事红包领取记录
export function addCompetitionPacketUser(data) {
  return request({
    url: '/platform/competition-packet-user/add',
    method: 'post',
    data: data
  })
}

// 修改赛事红包领取记录
export function updateCompetitionPacketUser(data) {
  return request({
    url: '/platform/competition-packet-user/edit',
    method: 'post',
    data: data
  })
}

// 删除赛事红包领取记录
export function delCompetitionPacketUser(data) {
  return request({
    url: '/platform/competition-packet-user/delete',
    method: 'post',
    data: data
  })
}
